import { READ } from '@wix/wix-data-client-common-standalone'
import { DEFAULT_PAGE_SIZE } from './pagination'

export const defaultDatasetConfiguration = {
  collectionName: null,
  readWriteType: READ,
  filter: null,
  sort: null,
  includes: null,
  includeFieldGroups: null,
  nested: [],
  pageSize: DEFAULT_PAGE_SIZE,
  deferred: false,
  onlyUsedFields: false,
} as const

export const getDefaultPageSize = ({
  maxPageSize,
  isSinglesCollection = false,
}: {
  maxPageSize?: number
  isSinglesCollection?: boolean
}) => {
  return isSinglesCollection
    ? 1
    : maxPageSize
      ? Math.min(maxPageSize, DEFAULT_PAGE_SIZE)
      : DEFAULT_PAGE_SIZE
}
